import React, { useState } from 'react';
import { IoCloseSharp } from "react-icons/io5";
// import { AxiosInstance } from '../../../../common/Loader/axios.config';
import Swal from 'sweetalert2';
import ClipLoader from 'react-spinners/ClipLoader';
import { AxiosInstance } from '../../../../common/Loader/axios.config';
import Select from 'react-select';

export default function CreateProjectModal({ isOpen, onClose, provider, fetchProjects }) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState('');
    const [price, setPrice] = useState('');
    const [location, setLocation] = useState('');
    const [region, setRegion] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [thumbnail, setThumbnail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [tags, setTags] = useState([]);
    const [selectedTag, setSelectedTag] = useState([]);

    const tagOptions = [
        { value: 'comedy', label: 'Comedy' },
        { value: 'drama', label: 'Drama' },
        { value: 'action', label: 'Action' },
        { value: 'adventure', label: 'Adventure' },
        { value: 'series', label: 'Series' },
    ];

    const handleTagChange = (options) => {
        setSelectedTag(options);
        const values = options.map(option => option.value);
        setTags(values);
    };

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('provider', provider);
        formData.append('name', name);
        formData.append('description', description);
        formData.append('category', category);
        formData.append('price', price);
        formData.append('location', location);
        formData.append('region', region);
        formData.append('startTime', startTime);
        formData.append('endTime', endTime);
        formData.append('age_restriction', "16");
        formData.append('resolution', "1080p");
        tags.forEach(tag => formData.append('tags[]', tag));
        if (thumbnail) {
            formData.append('logo', thumbnail);
        }

        console.log("Form Data:")
        for (let [key, value] of formData.entries()) {
            console.log(`${key}:`, value);
        }

        try {
            setLoading(true);
            const response = await AxiosInstance.post('/project', formData);

            console.log("Create Project Response", response);

            if (response.data.status === "success") {
                Swal.fire({
                    icon: "success",
                    title: "Project Created successfully! ",
                    text: `${name} has been created successfully!`,
                    showConfirmButton: false,
                    timer: 2000,
                });
                setLoading(false);
                fetchProjects();
                onClose();
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Failed to create project",
                    text: `${response.data.message}`,
                    showConfirmButton: false,
                    timer: 2000,
                });
                setLoading(false);
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Failed to create project",
                text: "An error occurred while creating the project.",
                showConfirmButton: false,
                timer: 2000,
            });
            setLoading(false);
            console.error('Network error:', error);
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75">
            <div className="bg-brand-background rounded-lg p-6 w-1/2">
                <div className='flex items-center justify-between'>
                    <h2 className="text-lg font-bold">Create a New Project</h2>
                    <button onClick={onClose} className="mt-4 bg-red-500 text-white rounded px-4 py-2">
                        <IoCloseSharp />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
                        <input type="text" id="name" name="name" className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                            value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="description" className="block text-sm font-medium text-gray-700">Description</label>
                        <textarea
                            id="description"
                            name="description"
                            className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                            rows={2}
                            value={description} onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>

                    <div className='w-full flex items-center gap-x-3'>
                        <div className="w-1/2 mb-4">
                            <label htmlFor="category" className="block text-sm font-medium text-gray-700">Category</label>
                            <select
                                name="category"
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                                className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
                                required
                            >
                                <option value="">Select Category...</option>
                                <option value="tv">TV</option>
                                <option value="vod">Video</option>
                                <option value="event">Event</option>
                                <option value="shorts">Shorts</option>
                                <option value="series">Series</option>
                            </select>
                        </div>
                        <div className="w-1/2 mb-4">
                            <label htmlFor="price" className="block text-sm font-medium text-gray-700">Price</label>
                            <input type="text" id="price" name="price" className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                                value={price} onChange={(e) => setPrice(e.target.value)} />
                        </div>
                    </div>

                    <div className='w-full flex items-center gap-x-3'>
                        <div className="w-1/2 mb-4">
                            <label htmlFor="location" className="block text-sm font-medium text-gray-700">Location</label>
                            <input type="text" id="location" name="location" className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                                value={location} onChange={(e) => setLocation(e.target.value)} />
                        </div>
                        <div className="w-1/2 mb-4">
                            <label htmlFor="region" className="block text-sm font-medium text-gray-700">Region</label>
                            <input type="text" id="region" name="region" className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                                value={region} onChange={(e) => setRegion(e.target.value)} />
                        </div>
                    </div>

                    <div className='w-full mb-4 text-black'>
                        <label className="mb-2 block text-white">Tags</label>
                        <Select
                            isMulti
                            value={selectedTag}
                            onChange={handleTagChange}
                            options={tagOptions}
                            placeholder="Select Tags..."
                        />
                    </div>

                    <div className='w-full flex items-center gap-x-3'>
                        <div className="w-1/2 mb-4">
                            <label htmlFor="startTime" className="block text-sm font-medium text-gray-700">Start Time</label>
                            <input type="datetime-local" id="startTime" name="startTime" className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                                value={startTime} onChange={(e) => setStartTime(e.target.value)} />
                        </div>
                        <div className="w-1/2 mb-4">
                            <label htmlFor="endTime" className="block text-sm font-medium text-gray-700">End Time</label>
                            <input type="datetime-local" id="endTime" name="endTime" className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                                value={endTime} onChange={(e) => setEndTime(e.target.value)} />
                        </div>
                    </div>

                    <div className="mb-4">
                        <label htmlFor="thumbnail" className="block text-sm font-medium text-gray-700">Thumbnail</label>
                        <input type="file" id="thumbnail" name="thumbnail" className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                            onChange={(e) => setThumbnail(e.target.files[0])} />
                    </div>
                    <div className="flex justify-end">
                        <button type="submit" className="bg-primary text-white p-2 rounded">
                            {loading ? <ClipLoader size={20} color="#FFFFFF" /> : "Create"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}